import styled from 'styled-components';

import { Display } from '@rover/kibble/core';
import { Props as DisplayProps } from '@rover/kibble/core/Display';
import MQ from '@rover/kibble/styles/MediaQuery';
import useTheme from '@rover/kibble/themes/useTheme';
import VerticalLayout from '@rover/react-lib/src/components/layouts/VerticalLayout';
import LinkOrganizer from '@rover/react-lib/src/components/lists/LinkOrganizer';
import { Anchor } from '@rover/types/src/Anchor';

const NUM_COLUMNS = 6;

export type Props = {
  citiesOrNeighborhoods: Anchor[];
  children?: React.ReactNode;
};

const StyledLayout = styled(VerticalLayout)`
  align-items: normal;
  margin-top: ${({ theme }) => theme.space['12x']};
  ${MQ.XS_DOWN.toString()} {
    margin-top: ${({ theme }) => theme.space['6x']};
  }
`;

const StyledLinkOrganizer = styled(LinkOrganizer)`
  ${MQ.XS_DOWN.toString()} {
    padding-left: 0;
  }
`;

const CitiesAndNeighborhoods = ({
  citiesOrNeighborhoods,
  children,
  ...props
}: Props): JSX.Element => {
  const { space } = useTheme();
  return (
    <StyledLayout {...props}>
      {children}
      <StyledLinkOrganizer
        links={citiesOrNeighborhoods}
        columnGap={space['6x']}
        columns={[NUM_COLUMNS / 3, NUM_COLUMNS / 2, NUM_COLUMNS]}
      />
    </StyledLayout>
  );
};

CitiesAndNeighborhoods.Display = ({ children, ...props }: DisplayProps): JSX.Element => {
  return (
    <Display webProps={{ as: 'h3', responsive: false }} size="500" textAlign="center" {...props}>
      {children}
    </Display>
  );
};

export default CitiesAndNeighborhoods;
